import React from "react";
import { Link } from "gatsby";
import { sortObjectsByDate } from "./../../modules/time.js";
import {
  TimelineWrapper,
  TimelineDiv,
  TimelineObject,
  YearsDiv,
  YearMarker,
} from "./elements";

const getFirstLastDates = (data) => {
  let firstDate = new Date();
  let lastDate = new Date("1/1/1900");
  for (let i = 0; i < data.length; i++) {
    const thisDate = new Date(data[i].date);
    const thisLastDate = data[i].isRange ? new Date(data[i].endDate) : thisDate;
    firstDate = thisDate < firstDate ? thisDate : firstDate;
    lastDate = thisLastDate > lastDate ? thisLastDate : lastDate;
  }
  const oneYear = 1000 * 60 * 60 * 24 * 365;
  firstDate = new Date(Date.parse(firstDate) - oneYear);
  lastDate = new Date(Date.parse(lastDate) + oneYear);
  return { firstDate, lastDate };
};

const TimelineComponent = ({ data }) => {
  const [firstLastDates, setFirstLastDates] = React.useState({});
  const [sortedObjects, setSortedObjects] = React.useState([]);
  const [years, setYears] = React.useState([]);
  const [oldLength, setOldLength] = React.useState(0);
  const [timelineWidth, setTimelineWidth] = React.useState(4000);

  React.useEffect(() => {
    // console.log("sorting the data!", data.length);
    setSortedObjects(sortObjectsByDate(data));
  }, [data]);

  const channels = 12;
  const timelineHeight = 800;
  const yearWidth = 200;

  const getPercentage = (thisDate) => {
    const thisDateNumber = Date.parse(thisDate);
    const firstDateNumber = Date.parse(firstLastDates.firstDate);
    const lastDateNumber = Date.parse(firstLastDates.lastDate);
    const span = lastDateNumber - firstDateNumber;
    const difference = thisDateNumber - firstDateNumber;
    return difference / span;
  };

  React.useEffect(() => {
    if (
      sortedObjects.length &&
      (!firstLastDates.firstDate || sortedObjects.length !== oldLength)
    ) {
      // console.log("spacing out the data!");
      const firstLast = getFirstLastDates(sortedObjects);
      setFirstLastDates(firstLast);
      // console.log("making years!");

      const { firstDate, lastDate } = firstLast;
      const firstDateYear = new Date(firstDate).getFullYear();
      const lastDateYear = new Date(lastDate).getFullYear();
      const newWidth = yearWidth * (lastDateYear - firstDateYear);
      setTimelineWidth(newWidth);
      const output = [];
      for (let i = firstDateYear; i <= lastDateYear; i++) {
        output[output.length] = new Date(`01/01/${i}`);
      }
      setYears(output);
      setOldLength(sortedObjects.length);
    }
  }, [firstLastDates, sortedObjects, oldLength]);
  return (
    <TimelineWrapper>
      <YearsDiv width={timelineWidth}>
        {years.map((year) => (
          <YearMarker key={year} left={getPercentage(year)}>
            {year.getFullYear()}
          </YearMarker>
        ))}
      </YearsDiv>
      <TimelineDiv
        width={timelineWidth}
        height={timelineHeight}
        channels={channels}
      >
        {sortedObjects.map((object, index) => {
          const myWidth = object.isRange
            ? getPercentage(object.endDate) - getPercentage(object.date)
            : 0;

          return (
            <TimelineObject
              objectType={object.type}
              key={index}
              top={index % channels}
              left={getPercentage(object.date)}
              objectWidth={myWidth}
            >
              {object.url && object.url.substring(0, 1) === "/" ? (
                <Link to={object.url}>{object.title}</Link>
              ) : (
                <a href={object.url} target="_blank" rel="noreferrer">
                  {object.title}
                </a>
              )}
            </TimelineObject>
          );
        })}
      </TimelineDiv>
      <p>(scroll right to see more)</p>
    </TimelineWrapper>
  );
};

export default TimelineComponent;
